import React from 'react'
import styled from 'styled-components'
import { array, object, func, string, number, oneOfType } from 'prop-types'
import pick from 'lodash/pick'

import { white, greyLight, black } from 'styles/colors'
import { borderRadius } from 'styles/global'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { fontSizes, fontWeights } from 'styles/typography'

import Icon from 'components/Icon'
import DownChevronLarge from 'icons/down-chevron-large.svg'

const Container = styled.div`
  position: static;
`

const Inner = styled.div`
  position: relative;
  display: block;
  border-radius: ${borderRadius};
  background-color: ${white};
  box-shadow: 0px 2px 21px rgba(0, 0, 0, 0.08);
`

const Label = styled.span`
  position: absolute;
  top: ${spacing.small};
  left: ${spacing.large};
  font-size: 9px;
  color: ${black};

  ${media.small`
    left: ${spacing.xLarge};
  `};
`

const Select = styled.select`
  display: block;
  border-radius: 0;
  background-color: ${white};
  width: 100%;
  resize: none;
  color: ${black};
  vertical-align: top;
  outline: 0;
  padding-left: ${spacing.large};
  padding-right: ${spacing.large};
  padding-top: ${spacing.large};
  padding-bottom: ${spacing.small};
  cursor: pointer;

  ${media.small`
    padding-left: ${spacing.xLarge};
    padding-right: ${spacing.xLarge};
  `};
`

const IconWrap = styled.div`
  position: absolute;
  top: 50%;
  right: ${spacing.large};
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  color: ${greyLight};

  ${media.small`
    right: ${spacing.xLarge};
  `};
`

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${spacing.small};

  ${media.small`
    padding-top: ${spacing.medium};
  `};
`

const Results = styled.span`
  font-size: ${fontSizes.tiny};
  color: ${black};
  font-weight: ${fontWeights.medium};
  display: block;
`

const PodsFilter = ({ options, field, results, ...rest }) => {
  const fieldProps = field || pick(rest, ['value', 'onChange', 'onBlur'])

  return (
    <Container>
      <Inner {...rest}>
        <Label>Filter by</Label>

        <Select {...fieldProps}>
          {options.map((option, i) => {
            return (
              <option key={i} value={option.value}>
                {option.label}
              </option>
            )
          })}
        </Select>
        <IconWrap>
          <Icon icon={<DownChevronLarge />} />
        </IconWrap>
      </Inner>
      {results && (
        <Footer>
          <Results>{results} items</Results>
        </Footer>
      )}
    </Container>
  )
}

PodsFilter.propTypes = {
  options: array.isRequired,
  onChange: func.isRequired,
  value: oneOfType([string, number]),
  field: object,
  results: number
}

export default PodsFilter
